<template>
    <v-row class="ma-0 pb-offset">
        <v-col class="pa-0" cols="12">
            <v-card class="mb-4 background-2 round-card elevation-2">
                <!-- Header -->
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Layout di Stampa Multiple {{ $trans(model) }}</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>

                <v-container class="pa-4" fluid>
                    <!-- Sezione Upload Template -->
                    <v-card outlined class="mb-4">
                        <v-card-subtitle class="d-flex align-center py-3">
                            <v-icon left color="primary">mdi-upload</v-icon>
                            <span class="text-subtitle-1 font-weight-medium">Carica Template</span>
                        </v-card-subtitle>
                        <v-divider></v-divider>
                        <v-card-text class="pa-4">
                            <file-uploader
                                :id="0"
                                :attachable-type="model"
                                :field="{'label': 'Template DOCX'}"
                                :options="{acceptedMimeTypes: '.docx', maxFiles: 10}"
                            ></file-uploader>
                        </v-card-text>
                    </v-card>

                    <!-- Sezione Variabili -->
                    <v-card outlined>
                        <v-card-subtitle class="d-flex align-center py-3">
                            <v-icon left color="primary">mdi-code-braces</v-icon>
                            <span class="text-subtitle-1 font-weight-medium">Variabili Disponibili</span>
                        </v-card-subtitle>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-row class="ma-0">
                                <!-- Colonna Variabili -->
                                <v-col cols="12" md="5" class="pa-4">
                                    <v-text-field
                                        v-model="search"
                                        prepend-icon="mdi-magnify"
                                        label="Cerca variabile..."
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        class="mb-3"
                                    ></v-text-field>

                                    <v-sheet class="variables-tree pa-2 rounded" outlined max-height="400" style="overflow-y: auto;">
                                        <v-treeview
                                            :active.sync="active"
                                            :open="open"
                                            :filter="filter"
                                            :search="search"
                                            :items="docxconversions"
                                            activatable
                                            shaped
                                            dense
                                            hoverable
                                            item-key="name"
                                            transition
                                            open-on-click
                                            return-object
                                            class="variables-treeview"
                                        >
                                            <template v-slot:prepend="{ item }">
                                                <v-icon v-if="item.icon" small color="primary">
                                                    {{ item.icon }}
                                                </v-icon>
                                                <v-icon v-else small color="grey">
                                                    mdi-tag-outline
                                                </v-icon>
                                            </template>
                                            <template v-slot:label="{ item }">
                                                <span class="text-body-2">{{ item.name }}</span>
                                            </template>
                                            <template v-slot:append="{ item, active }">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-show="active"
                                                            v-on="on"
                                                            icon
                                                            x-small
                                                            color="primary"
                                                            @click.stop="copyInClipBoard(item)"
                                                        >
                                                            <v-icon small>mdi-content-copy</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Copia negli appunti</span>
                                                </v-tooltip>
                                            </template>
                                        </v-treeview>
                                    </v-sheet>

                                    <!-- Descrizione variabile selezionata -->
                                    <v-slide-y-transition>
                                        <v-alert
                                            v-if="description"
                                            dense
                                            text
                                            type="info"
                                            class="mt-3 mb-0"
                                        >
                                            <span class="text-body-2">{{ description }}</span>
                                        </v-alert>
                                    </v-slide-y-transition>
                                </v-col>

                                <v-divider vertical class="d-none d-md-block"></v-divider>

                                <!-- Colonna Istruzioni -->
                                <v-col cols="12" md="7" class="pa-4">
                                    <v-expansion-panels flat accordion>
                                        <v-expansion-panel>
                                            <v-expansion-panel-header class="px-0">
                                                <div class="d-flex align-center">
                                                    <v-icon left color="amber darken-2">mdi-lightbulb-on</v-icon>
                                                    <span class="text-subtitle-1 font-weight-medium">Guida all'uso delle variabili</span>
                                                </div>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content class="px-0">
                                                <!-- Regola 1 -->
                                                <v-alert dense text color="primary" class="mb-3">
                                                    <div class="d-flex align-start">
                                                        <v-avatar color="primary" size="24" class="mr-3 mt-1">
                                                            <span class="white--text text-caption font-weight-bold">1</span>
                                                        </v-avatar>
                                                        <div>
                                                            <div class="font-weight-medium mb-1">Sintassi base</div>
                                                            <div class="text-body-2">
                                                                Racchiudi le variabili tra <code>${</code> e <code>}</code>
                                                            </div>
                                                            <v-chip small outlined color="primary" class="mt-2 font-weight-medium">
                                                                ${NOME_AZIENDA}
                                                            </v-chip>
                                                        </div>
                                                    </div>
                                                </v-alert>

                                                <!-- Regola 2 -->
                                                <v-alert dense text color="primary" class="mb-3">
                                                    <div class="d-flex align-start">
                                                        <v-avatar color="primary" size="24" class="mr-3 mt-1">
                                                            <span class="white--text text-caption font-weight-bold">2</span>
                                                        </v-avatar>
                                                        <div>
                                                            <div class="font-weight-medium mb-1">Separazione variabili</div>
                                                            <div class="text-body-2">
                                                                Separa le variabili con almeno uno spazio.
                                                            </div>
                                                            <div class="mt-2">
                                                                <v-chip small color="error" outlined class="mr-2">
                                                                    <v-icon left x-small>mdi-close</v-icon>
                                                                    ${A}${B}
                                                                </v-chip>
                                                                <v-chip small color="success" outlined>
                                                                    <v-icon left x-small>mdi-check</v-icon>
                                                                    ${A} ${B}
                                                                </v-chip>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-alert>

                                                <!-- Regola 3 - Cicli -->
                                                <v-alert dense text color="deep-purple" class="mb-3">
                                                    <div class="d-flex align-start">
                                                        <v-avatar color="deep-purple" size="24" class="mr-3 mt-1">
                                                            <span class="white--text text-caption font-weight-bold">3</span>
                                                        </v-avatar>
                                                        <div>
                                                            <div class="font-weight-medium mb-1">Cicli per collezioni</div>
                                                            <div class="text-body-2 mb-2">
                                                                Usa i cicli per stampare liste (es. prodotti, interventi).
                                                            </div>
                                                            <v-sheet outlined rounded class="pa-2 text-body-2" style="font-family: monospace; background: rgba(0,0,0,0.03);">
                                                                <span class="deep-purple--text">${PRODOTTI_ORDINE}</span><br>
                                                                <span class="pl-4">Nome: ${NOME_PRODOTTO_ORDINE}</span><br>
                                                                <span class="pl-4">Q.tà: ${QUANTITA_PRODOTTO_ORDINE}</span><br>
                                                                <span class="deep-purple--text">${/PRODOTTI_ORDINE}</span>
                                                            </v-sheet>
                                                        </div>
                                                    </div>
                                                </v-alert>

                                                <!-- Regola 4 - Condizioni -->
                                                <v-alert dense text color="teal" class="mb-0">
                                                    <div class="d-flex align-start">
                                                        <v-avatar color="teal" size="24" class="mr-3 mt-1">
                                                            <span class="white--text text-caption font-weight-bold">4</span>
                                                        </v-avatar>
                                                        <div>
                                                            <div class="font-weight-medium mb-1">Blocchi condizionali</div>
                                                            <div class="text-body-2 mb-2">
                                                                Mostra contenuto solo se la variabile esiste.
                                                            </div>
                                                            <v-sheet outlined rounded class="pa-2 text-body-2" style="font-family: monospace; background: rgba(0,0,0,0.03);">
                                                                <span class="teal--text">${SE-DESTINAZIONE_ORDINE}</span><br>
                                                                <span class="pl-4">Dest: ${NOME_DESTINAZIONE}</span><br>
                                                                <span class="teal--text">${/SE-DESTINAZIONE_ORDINE}</span>
                                                            </v-sheet>
                                                        </div>
                                                    </div>
                                                </v-alert>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-container>
            </v-card>
        </v-col>

        <!-- Snackbar per feedback copia -->
        <v-snackbar
            v-model="copySnackbar"
            :timeout="2000"
            color="success"
            top
        >
            <v-icon left>mdi-check-circle</v-icon>
            Variabile copiata negli appunti!
        </v-snackbar>
    </v-row>
</template>

<script>
import FileUploader from '@/components/common/FileUploader'
import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'

export default {
    name: 'print-setting',
    components: {
        FileUploader
    },
    mixins: [SettingsOptionsMixin],
    props: {
        model: String
    },

    data() {
        return {
            layouts: [],
            docxconversions: [],
            active: [],
            open: [],
            search: null,
            settings: {},
            copySnackbar: false
        }
    },

    computed: {
        description() {
            if (this.active.length > 0 && this.active[0])
                return this.active[0].description
            return ''
        },

        filter() {
            return (item, search, textKey) => item[textKey].indexOf(search.toUpperCase()) > -1
        }
    },

    methods: {
        copyInClipBoard(item) {
            const textToCopy = '${' + item.name + '}'
            navigator.clipboard.writeText(textToCopy).then(() => {
                this.copySnackbar = true
            }, (err) => {
                console.error('Could not copy text: ', err)
            })
        }
    },

    created() {
        this.axios.get('docxconversions-info/' + this.model).then(response => {
            this.docxconversions = response.data.data.info
        })
    }
}
</script>

<style scoped>
.variables-tree {
    background-color: rgba(0, 0, 0, 0.02);
}

.variables-treeview {
    font-size: 13px;
}

.variables-treeview .v-treeview-node--active {
    background-color: rgba(25, 118, 210, 0.08);
}

.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
    padding: 0 0 16px 0;
}

code {
    background-color: rgba(0, 0, 0, 0.05);
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
    color: #d63384;
}
</style>
